import { render, staticRenderFns } from "./InvitePartner.vue?vue&type=template&id=3ff502f5&scoped=true&"
import script from "./InvitePartner.vue?vue&type=script&lang=js&"
export * from "./InvitePartner.vue?vue&type=script&lang=js&"
import style0 from "./InvitePartner.vue?vue&type=style&index=0&id=3ff502f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff502f5",
  null
  
)

export default component.exports